import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Wifi, WifiOff } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { AdminTitle, Btn } from "@/pages/admin/Admin";

export default function Broadcast() {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const [subject, setSubject] = useState("Kabar dari Craftendemic");
  const [ch, setCh] = useState({ whatsapp: true, email: true });
  const load = () => api.get("/admin/broadcasts").then((r) => setD(r.data));
  useEffect(() => { load(); const id = setInterval(load, 8000); return () => clearInterval(id); }, []);
  const channels = Object.keys(ch).filter((k) => ch[k]);
  const send = async () => {
    if (!window.confirm(`Send this message by ${channels.join(" + ")} to subscribed customers?`)) return;
    try { await api.post("/admin/broadcasts", { message: msg, subject, channels }); setMsg(""); toast.success("Broadcast started"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!d) return null;
  const dev = d.device;
  return (
    <div className="space-y-6 max-w-4xl" data-testid="admin-broadcast">
      <AdminTitle>Broadcast (WhatsApp & Email)</AdminTitle>
      <div className={`p-4 text-sm flex items-center gap-3 border ${dev.connected ? "border-[#2E6B40]/40 bg-[#2E6B40]/5" : "border-[#C87D17]/50 bg-[#C87D17]/10"}`} data-testid="wa-device-status">
        {dev.connected ? <Wifi size={16} /> : <WifiOff size={16} />}
        {dev.connected ? `Fonnte device ${dev.device} connected · quota ${dev.quota} · until ${dev.expired}`
          : `WhatsApp device ${dev.device || ""} is ${dev.status || "not connected"} — open fonnte.com > Device and scan the QR code. Messages fail until connected. ${dev.detail || ""}`}
      </div>
      <div className="bg-white border border-[#E6DFD5] p-6 space-y-4">
        <p className="text-sm text-[#6E6259]">Goes only to customers who opted in. WhatsApp needs a saved number (<strong data-testid="wa-audience-count">{d.audience}</strong> people). Use {"{name}"} for first name. An unsubscribe note is added automatically.</p>
        <div className="flex gap-6 text-sm">
          {[["whatsapp", "WhatsApp"], ["email", "Email"]].map(([k, l]) => (
            <label key={k} className="flex items-center gap-2"><input type="checkbox" checked={ch[k]} onChange={(e) => setCh({ ...ch, [k]: e.target.checked })} data-testid={`broadcast-channel-${k}`} />{l}</label>
          ))}
        </div>
        {ch.email && <input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Email subject" className="w-full border border-[#E6DFD5] p-3 text-sm" data-testid="broadcast-subject-input" />}
        <textarea rows={5} value={msg} onChange={(e) => setMsg(e.target.value)} placeholder="Halo {name}, koleksi baru sudah hadir! Pakai kode ..." data-testid="broadcast-message-input" className="w-full border border-[#E6DFD5] p-3 text-sm" />
        <Btn onClick={send} disabled={msg.trim().length < 5 || !channels.length} className="flex items-center gap-2" data-testid="broadcast-send-btn"><Send size={14} />Send broadcast</Btn>
      </div>
      <div className="bg-white border border-[#E6DFD5] divide-y divide-[#E6DFD5]">
        <p className="p-4 text-sm font-medium">Campaigns</p>
        {d.broadcasts.map((b) => (
          <div key={b.broadcast_id} className="p-4 text-sm flex justify-between gap-4" data-testid={`broadcast-row-${b.broadcast_id}`}>
            <span className="flex-1 line-clamp-2">{b.message}</span>
            <span className="text-xs text-[#6E6259] whitespace-nowrap">{b.status} · WA {b.sent} sent / {b.failed} failed · email {b.emailed || 0}</span>
          </div>
        ))}
        {!d.broadcasts.length && <p className="p-4 text-sm text-[#6E6259]">No campaigns yet.</p>}
      </div>
      <div className="bg-white border border-[#E6DFD5] divide-y divide-[#E6DFD5]">
        <p className="p-4 text-sm font-medium">Recent WhatsApp messages (orders & broadcasts)</p>
        {d.logs.map((l) => (
          <div key={l.log_id} className="p-3 text-xs flex gap-4 font-mono">
            <span className="w-44 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</span><span className="w-24">{l.kind}</span>
            <span className="w-32">{l.phone || "—"}</span><span className={l.status === "sent" ? "text-[#2E6B40]" : "text-[#9E2A2B]"}>{l.status}</span>
            <span className="flex-1 truncate text-[#6E6259]">{l.ref} {l.error || l.response?.reason || ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
